import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row mb-2"
};
const _hoisted_2 = { class: "col" };
const _hoisted_3 = { class: "h5 mb-0" };
const _hoisted_4 = {
    key: 0,
    class: "small fst-italic"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_cms_block = _resolveComponent("g-cms-block");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
                    (_ctx.subTitle)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.subTitle), 1))
                        : _createCommentVNode("", true)
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.content.slots)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.content.slots, (slot) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (_ctx.isRowSlow(slot))
                        ? (_openBlock(), _createBlock(_component_g_cms_block, {
                            key: 0,
                            content: slot
                        }, null, 8, ["content"]))
                        : (_openBlock(), _createElementBlock("div", _mergeProps({
                            key: 1,
                            class: "row"
                        }, slot?.config?.row), [
                            _createElementVNode("div", _mergeProps({ class: "col" }, slot?.config?.column), [
                                _createVNode(_component_g_cms_block, { content: slot }, null, 8, ["content"])
                            ], 16)
                        ], 16))
                ], 64));
            }), 256))
            : _createCommentVNode("", true)
    ], 64));
}
